module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "order-header",
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createOrder
    }
  }, [_vm._v("新建PI")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("筛选：")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "筛选PI类型",
      "allowClear": ""
    },
    on: {
      "change": _vm.handleTypeChange
    },
    model: {
      value: (_vm.selectedType),
      callback: function($$v) {
        _vm.selectedType = $$v
      },
      expression: "selectedType"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("\n                    筛选PI类型\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n                    境外单\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("\n                    境内单\n                ")])], 1), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "筛选PI类型",
      "allowClear": ""
    },
    on: {
      "change": _vm.handleStatusChange
    },
    model: {
      value: (_vm.selectedStatus),
      callback: function($$v) {
        _vm.selectedStatus = $$v
      },
      expression: "selectedStatus"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("\n                    筛选PI状态\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n                    未结单\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("\n                    已结单\n                ")])], 1), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "default-value": "lucy",
      "placeholder": "筛选国家地区",
      "allowClear": ""
    },
    on: {
      "change": _vm.handleCountryChange
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("\n                    筛选国家地区\n                ")]), _vm._v(" "), _vm._l((_vm.config.countries), function(c, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": c.code
      }
    }, [_vm._v("\n                    " + _vm._s(c.name) + " (" + _vm._s(c.code) + ")\n                ")])
  })], 2), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "输入客户名以搜索",
      "allowClear": true
    },
    on: {
      "change": _vm.handleCustomerChange
    },
    model: {
      value: (_vm.selectedCustomer),
      callback: function($$v) {
        _vm.selectedCustomer = $$v
      },
      expression: "selectedCustomer"
    }
  }), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "输入货代名以搜索",
      "allowClear": true
    },
    on: {
      "change": _vm.handleFreightChange
    },
    model: {
      value: (_vm.selectedFreight),
      callback: function($$v) {
        _vm.selectedFreight = $$v
      },
      expression: "selectedFreight"
    }
  }), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "输入产品名以搜索",
      "allowClear": true
    },
    on: {
      "change": _vm.handleProductNameChange
    },
    model: {
      value: (_vm.selectedProductName),
      callback: function($$v) {
        _vm.selectedProductName = $$v
      },
      expression: "selectedProductName"
    }
  }), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "输入PINo.以搜索",
      "allowClear": true
    },
    on: {
      "change": _vm.handlePINoChange
    },
    model: {
      value: (_vm.selectedPINo),
      callback: function($$v) {
        _vm.selectedPINo = $$v
      },
      expression: "selectedPINo"
    }
  }), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("重置筛选条件")]), _vm._v(" "), _c('a-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.admin),
      expression: "admin"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.data,
      "size": "middle",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "type",
      fn: function(type) {
        return _c('span', {}, [(type == 1) ? _c('a-tag', {
          attrs: {
            "color": "orange"
          }
        }, [_vm._v("\n          境外单\n        ")]) : _vm._e(), _vm._v(" "), (type == 2) ? _c('a-tag', {
          attrs: {
            "color": "geekblue"
          }
        }, [_vm._v("\n          境内单\n        ")]) : _vm._e()], 1)
      }
    }, {
      key: "status",
      fn: function(status) {
        return _c('span', {}, [(status == 1) ? _c('a-tag', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("\n          未结单\n        ")]) : _vm._e(), _vm._v(" "), (status == 2) ? _c('a-tag', {
          attrs: {
            "color": "green"
          }
        }, [_vm._v("\n          已结单\n        ")]) : _vm._e()], 1)
      }
    }, {
      key: "region",
      fn: function(region) {
        return _c('span', {}, [(_vm.config.countries) ? _c('span', [_vm._v(_vm._s(_vm.config.countries.find(function (t) { return t.code == region; }).name) + " ")]) : _vm._e(), _vm._v(" (" + _vm._s(region) + ")\n      ")])
      }
    }, {
      key: "firstProduct",
      fn: function(text, record) {
        return _c('span', {}, [(record.products && record.products.length > 0) ? _c('span', [_vm._v(_vm._s(record.products[0].productName) + " ")]) : _vm._e()])
      }
    }, {
      key: "firstProductCount",
      fn: function(text, record) {
        return _c('span', {}, [(record.products && record.products.length > 0) ? _c('span', [_vm._v(_vm._s(record.products[0].productCount) + " ")]) : _vm._e()])
      }
    }, {
      key: "dollarProfitTotal",
      fn: function(text, record) {
        return _c('span', {}, [(record.type == 1) ? _c('span', [_vm._v(_vm._s(record.profitTotal) + " ")]) : _vm._e(), _vm._v(" "), (record.type == 2) ? _c('span') : _vm._e()])
      }
    }, {
      key: "profitTotal",
      fn: function(text, record) {
        return _c('span', {}, [(record.type == 1) ? _c('span', [_vm._v(_vm._s((record.profitTotal * 7.1).toFixed(2)) + " ")]) : _vm._e(), _vm._v(" "), (record.type == 2) ? _c('span', [_vm._v(_vm._s(parseFloat(record.profitTotal).toFixed(2)) + " ")]) : _vm._e()])
      }
    }, {
      key: "action",
      fn: function(text, record) {
        return _c('span', {}, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.edit(record)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('a-divider', {
          attrs: {
            "type": "vertical"
          }
        }), _vm._v(" "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.deleteOrder(record)
            }
          }
        }, [_vm._v("删除")])], 1)
      }
    }])
  }), _vm._v(" "), (_vm.data.length > 0 && _vm.summary != null) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "justify-content": "space-between",
      "display": "flex",
      "padding": "0px 10px"
    }
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "total-item"
  }, [_vm._v("产品: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalProductCount.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("合同金额: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalProductPrice.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("实收: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalIncome.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("采购: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalProcument.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("物流: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalShipping.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("佣金: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalBrokerage.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("其他: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalOther.toFixed(2)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.admin),
      expression: "admin"
    }],
    staticClass: "total-item"
  }, [_vm._v("利润: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.summary.totalProfit.toFixed(2)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.admin),
      expression: "admin"
    }],
    staticClass: "total-item"
  }, [_vm._v("利润率: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s((_vm.summary.totalProfitRate * 100).toFixed(2)))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "overflow": "hidden"
    }
  }, [_c('a-pagination', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "show-total": function (total) { return ("共 " + total + " 条"); },
      "total": _vm.total,
      "show-quick-jumper": "",
      "pageSize": _vm.pageSize
    },
    on: {
      "change": _vm.onPageChange
    },
    model: {
      value: (_vm.pageNumber),
      callback: function($$v) {
        _vm.pageNumber = $$v
      },
      expression: "pageNumber"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(" 每页 "), _c('a-select', {
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "default-value": "lucy"
    },
    on: {
      "change": _vm.changePageSize
    },
    model: {
      value: (_vm.pageSize),
      callback: function($$v) {
        _vm.pageSize = $$v
      },
      expression: "pageSize"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("\n                    10\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("\n                    15\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("\n                    20\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("\n                    30\n                ")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("\n                    50\n                ")])], 1), _vm._v(" 条\n        ")], 1)], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": _vm.mode == 'create' ? '创建PI' : '编辑PI',
      "ok-text": "保存PI信息",
      "cancel-text": "取消",
      "width": "1200px"
    },
    on: {
      "ok": _vm.submitCreateModal
    },
    model: {
      value: (_vm.createModal),
      callback: function($$v) {
        _vm.createModal = $$v
      },
      expression: "createModal"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('a-form-model', {
    attrs: {
      "model": _vm.form,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "合同编号"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.form.orderPre) + " "), _c('a-input', {
    staticStyle: {
      "width": "60px"
    },
    model: {
      value: (_vm.form.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderNo", $$v)
      },
      expression: "form.orderNo"
    }
  }), _vm._v(" " + _vm._s(_vm.form.orderPost) + "\n                    ")], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "合同类型"
    }
  }, [_c('a-radio-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n                            境外单\n                            ")]), _vm._v(" "), _c('a-radio', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("\n                            境内单\n                            ")])], 1)], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('a-radio-group', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n                            未结单\n                            ")]), _vm._v(" "), _c('a-radio', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("\n                            已结单\n                            ")])], 1)], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "提单日(ETD)"
    }
  }, [_c('a-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.form.etd),
      callback: function($$v) {
        _vm.$set(_vm.form, "etd", $$v)
      },
      expression: "form.etd"
    }
  })], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "到港日(ETA)"
    }
  }, [_c('a-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.form.eta),
      callback: function($$v) {
        _vm.$set(_vm.form, "eta", $$v)
      },
      expression: "form.eta"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('a-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('a-form-model', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "国家简称"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "选择国家简称"
    },
    model: {
      value: (_vm.form.region),
      callback: function($$v) {
        _vm.$set(_vm.form, "region", $$v)
      },
      expression: "form.region"
    }
  }, _vm._l((_vm.config.countries), function(c, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": c.code
      }
    }, [_vm._v("\n                            " + _vm._s(c.name) + " (" + _vm._s(c.code) + ")\n                            ")])
  }), 1)], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "客户名称"
    }
  }, [_c('a-input', {
    model: {
      value: (_vm.form.customer),
      callback: function($$v) {
        _vm.$set(_vm.form, "customer", $$v)
      },
      expression: "form.customer"
    }
  })], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "销售人员"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "选择销售人员"
    },
    model: {
      value: (_vm.form.sales),
      callback: function($$v) {
        _vm.$set(_vm.form, "sales", $$v)
      },
      expression: "form.sales"
    }
  }, _vm._l((_vm.config.sales), function(sale, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": sale
      }
    }, [_vm._v("\n                            " + _vm._s(sale) + "\n                            ")])
  }), 1)], 1), _vm._v(" "), _c('a-form-model-item', {
    attrs: {
      "label": "佣金汇总"
    }
  }, [_c('a-input-number', {
    model: {
      value: (_vm.form.brokerage),
      callback: function($$v) {
        _vm.$set(_vm.form, "brokerage", $$v)
      },
      expression: "form.brokerage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('a-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.productColumns,
      "dataSource": _vm.products,
      "size": "small",
      "pagination": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.productNumberColumns), function(temp) {
      return {
        key: temp,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input-number', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleProductChange(e, record.key, temp); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.productEditableColumns), function(temp1) {
      return {
        key: temp1,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleProductChange(e.target.value, record.key, temp1); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.productFixedColumns), function(s) {
      return {
        key: s,
        fn: function(text, record, index) {
          return [_c('div', [_c('span', [_vm._v(" " + _vm._s(parseFloat(text).toFixed(2)))])])]
        }
      }
    }), {
      key: "action",
      fn: function(text, record, index) {
        return _c('span', {}, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.deleteProduct(index)
            }
          }
        }, [_vm._v("删除")])])
      }
    }], null, true)
  }), _vm._v(" "), (_vm.products.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "justify-content": "space-between",
      "display": "flex",
      "padding": "0px 10px"
    }
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "total-item"
  }, [_vm._v("数量: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.getProductTotal().count))])]), _vm._v(" "), _c('div', {
    staticClass: "total-item"
  }, [_vm._v("总量: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.getProductTotal().total))])])])]) : _vm._e(), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v("添加产品")], 1)], 1)], 1), _vm._v(" "), _c('a-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a-tabs', {
    attrs: {
      "default-active-key": "2",
      "tab-position": "top",
      "type": "card"
    }
  }, [_c('a-tab-pane', {
    key: "2",
    attrs: {
      "tab": "采购"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.procumentColumns,
      "dataSource": _vm.procuments,
      "size": "small",
      "pagination": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.procumentNumberColumns), function(temp3) {
      return {
        key: temp3,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input-number', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleProcumentChange(e, record.key, temp3); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.procumentEditableColumns), function(temp4) {
      return {
        key: temp4,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleProcumentChange(e.target.value, record.key, temp4); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.procumentFixedColumns), function(temp5) {
      return {
        key: temp5,
        fn: function(text, record, index) {
          return [_c('div', [_c('span', [_vm._v(" " + _vm._s(parseFloat(text).toFixed(2)))])])]
        }
      }
    }), {
      key: "action",
      fn: function(text, record) {
        return _c('span', {}, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.deleteProcument(_vm.index)
            }
          }
        }, [_vm._v("删除")])])
      }
    }], null, true)
  }), _vm._v(" "), (_vm.procuments.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "justify-content": "space-between",
      "display": "flex",
      "padding": "0px 10px"
    }
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "total-item"
  }, [_vm._v("最终采购成本总量: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.getProcumentTotal().total))])])])]) : _vm._e(), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addProcument
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v("添加采购")], 1)], 1), _vm._v(" "), _c('a-tab-pane', {
    key: "3",
    attrs: {
      "tab": "物流"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.shippingColumns,
      "dataSource": _vm.shippings,
      "size": "small",
      "pagination": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.shippingNumberColumns), function(temp6) {
      return {
        key: temp6,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input-number', {
            staticStyle: {
              "width": "70px"
            },
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleShippingChange(e, record.key, temp6); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.shippingEditableColumns), function(temp7) {
      return {
        key: temp7,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleShippingChange(e.target.value, record.key, temp7); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.shippingFixedColumns), function(temp8) {
      return {
        key: temp8,
        fn: function(text, record, index) {
          return [_c('div', [_c('span', [_vm._v(" " + _vm._s(parseFloat(text).toFixed(2)))])])]
        }
      }
    }), {
      key: "action",
      fn: function(text, record) {
        return _c('span', {}, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.deleteShipping(_vm.index)
            }
          }
        }, [_vm._v("删除")])])
      }
    }], null, true)
  }), _vm._v(" "), (_vm.shippings.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "justify-content": "space-between",
      "display": "flex",
      "padding": "0px 10px"
    }
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "total-item"
  }, [_vm._v("最终物流总量: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.getShippingTotal().total))])])])]) : _vm._e(), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addShipping
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v("添加物流")], 1)], 1), _vm._v(" "), _c('a-tab-pane', {
    key: "4",
    attrs: {
      "tab": "银行费用"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.bankCostColumns,
      "dataSource": _vm.bankcosts,
      "size": "small",
      "pagination": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.bankcostNumberColumns), function(temp10) {
      return {
        key: temp10,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input-number', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleBankcostChange(e, record.key, temp10); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.bankcostEditableColumns), function(temp11) {
      return {
        key: temp11,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleBankcostChange(e.target.value, record.key, temp11); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.bankcostFixedColumns), function(temp12) {
      return {
        key: temp12,
        fn: function(text, record, index) {
          return [_c('div', [_c('span', [_vm._v(" " + _vm._s(parseFloat(text).toFixed(2)))])])]
        }
      }
    }), {
      key: "actualIncomeDate",
      fn: function(text, record, index) {
        return [(record.mode == 'edit') ? _c('a-date-picker', {
          attrs: {
            "value": record.actualIncomeDate,
            "type": "date",
            "placeholder": "选择日期"
          },
          on: {
            "change": function (e) { return _vm.handleDateChange(e, record.key); }
          }
        }) : _c('span', [_vm._v(_vm._s(record.actualIncomeDate.format('yyyy-MM-DD')))])]
      }
    }, {
      key: "action",
      fn: function(text, record) {
        return _c('span', {}, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.deleteBankcost(_vm.index)
            }
          }
        }, [_vm._v("删除")])])
      }
    }], null, true)
  }), _vm._v(" "), (_vm.bankcosts.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "justify-content": "space-between",
      "display": "flex",
      "padding": "0px 10px"
    }
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "total-item"
  }, [_vm._v("最终实收总量: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.getBankTotal().total))])])])]) : _vm._e(), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addBankcost
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v("添加银行费用")], 1)], 1), _vm._v(" "), _c('a-tab-pane', {
    key: "5",
    attrs: {
      "tab": "其他费用"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.otherColumns,
      "dataSource": _vm.others,
      "size": "small",
      "pagination": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.otherNumberColumns), function(temp13) {
      return {
        key: temp13,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input-number', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleOtherChange(e, record.key, temp13); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.otherEditableColumns), function(temp14) {
      return {
        key: temp14,
        fn: function(text, record, index) {
          return [_c('div', [(record.mode == 'edit') ? _c('a-input', {
            attrs: {
              "value": text
            },
            on: {
              "change": function (e) { return _vm.handleOtherChange(e.target.value, record.key, temp14); }
            }
          }) : _c('span', [_vm._v(" " + _vm._s(text))])], 1)]
        }
      }
    }), _vm._l((_vm.otherFixedColumns), function(temp15) {
      return {
        key: temp15,
        fn: function(text, record, index) {
          return [_c('div', [_c('span', [_vm._v(" " + _vm._s(parseFloat(text).toFixed(2)))])])]
        }
      }
    }), {
      key: "action",
      fn: function(text, record) {
        return _c('span', {}, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.deleteOther(_vm.index)
            }
          }
        }, [_vm._v("删除")])])
      }
    }], null, true)
  }), _vm._v(" "), (_vm.others.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "justify-content": "space-between",
      "display": "flex",
      "padding": "0px 10px"
    }
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "total-item"
  }, [_vm._v("其他费用总量: "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.getOtherTotal().total))])])])]) : _vm._e(), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addOther
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v("添加其他费用")], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81906d1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/orders.vue
// module id = 1399
// module chunks = 1